import { useFormType } from "./hooks/useForm";


export default function FormHeader({ isNewEntity, entityName, form, idProp, isCopy }: { isNewEntity: boolean, entityName: string, form: useFormType, idProp: string, isCopy: boolean }) {



    return (<>
        {!isNewEntity ? <div style={{ display: 'flex', justifyContent: 'space-between' }}>

            <h3 className="font-bold text-[1.3em]">{`${entityName}`} {form.state[idProp] ? `${form.state?.id}` : ''}</h3>
            <div >
            </div>
        </div> : 
        
        <div className="font-bold text-[1.3em] mb-3">
            {isCopy ? <h3>Formulário para criação de cópia de {entityName}</h3> : <h3>Formulário para criação de {entityName}</h3>}
        </div>}
    </>)

}